import type { CommunitySettings } from "..";
import { FormProvider, useForm } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-shared/uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { MobileHomeSegments } from "../../MobileApp/MobileAppFormFields/MobileHomeSegments";

export const MobileNavigationForm = ({
  defaultValues,
  handleSubmit,
  isSaving,
}: {
  defaultValues: any;
  handleSubmit: (communitySettings: CommunitySettings) => void;
  isSaving: boolean;
}) => {
  const methods = useForm<Record<string, any>>({
    defaultValues: defaultValues,
    mode: "onChange",
  });

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit} defaultValues={defaultValues}>
        <div className="bg-tertiary mt-2 rounded-lg px-6 py-5">
          <MobileHomeSegments />
        </div>
        <div className="mt-6 flex justify-end">
          <Button type="submit" variant="circle" disabled={isSaving}>
            {isSaving ? t("saving") : t("save_changes")}
          </Button>
        </div>
      </Form>
    </FormProvider>
  );
};
